var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['email-component', 'divider-component', { selected: _vm.selected }],style:(_vm.containerStyles),on:{"click":_vm.handleClick}},[_c('hr',{style:(_vm.dividerStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }